import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const readonlyDropdownOptionStyle = css`
  margin-bottom: ${theme.spacing(0)};

  border: none;
  background-color: ${theme.colors.neutral[5]};

  > div {
    opacity: 0.7;
  }
  > label {
    color: ${theme.colors.text.default};
    opacity: unset;
    flex: 1;
    overflow: hidden;
  }
  > p {
    color: ${theme.colors.text.default};
  }
`;

export const readonlyDropdownContainerStyle = css`
  margin-bottom: ${theme.spacing(3)};
`;
